import {
  CREATE_CRON_LOADING,
  CREATE_CRON_SUCCESS,
  CREATE_CRON_ERROR,
  FETCH_CRONS_LOADING,
  FETCH_CRONS_SUCCESS,
  FETCH_CRONS_ERROR,
  DELETE_CRON_LOADING,
  DELETE_CRON_SUCCESS,
  DELETE_CRON_ERROR
} from '../Types/cronTypes';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null
};

const cronReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CRONS_LOADING:
      return { ...state, isLoading: true, error: null, success: null };
    case FETCH_CRONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: null,
        success: 'Cron jobs fetched successfully'
      };
    case FETCH_CRONS_ERROR:
      return { ...state, isLoading: false, error: action.payload, success: null };
    case CREATE_CRON_LOADING:
      return { ...state, isLoading: true, error: null, success: null };
    case CREATE_CRON_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: state.data.some(cron => cron._id === action.payload._id)
          ? state.data.map(cron => (cron._id === action.payload._id ? action.payload : cron))
          : [...state.data, action.payload],
        error: null,
        success: 'Cron job managed successfully'
      };
    case CREATE_CRON_ERROR:
      return { ...state, isLoading: false, error: action.payload, success: null };
    case DELETE_CRON_LOADING:
      return { ...state, isLoading: true, error: null, success: null };
    case DELETE_CRON_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: state.data.filter(cron => cron._id !== action.payload),
        error: null,
        success: 'Cron job deleted successfully'
      };
    case DELETE_CRON_ERROR:
      return { ...state, isLoading: false, error: action.payload, success: null };
    default:
      return state;
  }
};

export default cronReducer;
